import React, { useEffect, useState } from "react";
import axios from "axios";
import { Table, Button } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const Community = () => {
    const [communityData, setCommunityData] = useState([]);
    const [loading, setLoading] = useState(true);

    // Fetch community data
    const fetchCommunityData = async () => {
        try {
            const response = await axios.get("https://api.biznetusa.com/api/get-community");
            setCommunityData(response.data.community);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching community data:", error);
            setLoading(false);
        }
    };

    // Handle delete operation
    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this record?")) {
            try {
                await axios.delete(`https://api.biznetusa.com/api/deletecommunity/${id}`);
                setCommunityData(communityData.filter((item) => item.id !== id));
                toast.success("Record deleted successfully!");
                
            } catch (error) {
                console.error("Error deleting the record:", error);
                toast.error("Failed to delete the record.");
            }
        }
    };

    useEffect(() => {
        fetchCommunityData();
    }, []);

    return (
        <div className="container mt-4">
            <h2>Community List</h2>
            <ToastContainer />
            {loading ? (
                <p>Loading data...</p>
            ) : (
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>Email</th>
                            <th>Phone</th>
                            <th>Area of Interest</th>
                            <th>Location</th>
                            <th>Document</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {communityData.length > 0 ? (
                            communityData.map((item) => (
                                <tr key={item.id}>
                                    <td>{item.id}</td>
                                    <td>{item.f_name}</td>
                                    <td>{item.l_name}</td>
                                    <td>{item.email}</td>
                                    <td>{item.phone}</td>
                                    <td>{item.area_of_interst}</td>
                                    <td>{item.location}</td>
                                    <td>
                                        <a href={`https://api.biznetusa.com/uploads/resume/${item.upload_documents}`} target="_blank" rel="noopener noreferrer">
                                            View Document
                                        </a>
                                    </td>
                                    <td>
                                        <Button variant="danger" onClick={() => handleDelete(item.id)}>
                                            Delete
                                        </Button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="9" className="text-center">
                                    No data available.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            )}
        </div>
    );
};

export default Community;
